// extracted by mini-css-extract-plugin
export default {"container":"FindHotspotField__container___FO0Iz","headerContainer":"FindHotspotField__headerContainer___ovlDh","leftContainer":"FindHotspotField__leftContainer___Kx6pA"};